<template>
  <div class="result_box">
    <div v-show="applyStatus === '02'">
      <img
        class="result_img"
        src="@/assets/img/mobile-img/sign-pending.png"
        alt=""
      />
      <p class="result_title">您已提交银联商务入驻申请，请等待审核结果</p>
    </div>
    <div v-show="applyStatus === '03'">
      <img
        class="result_img"
        src="@/assets/img/mobile-img/sign-success.png"
        alt=""
      />
      <p class="result_title">恭喜，您的银联商务入驻申请审核已通过</p>
      <div class="result_success_box">
        <div>
          <p>商户编号：{{ merNo }}</p>
          <p>企业号：{{ companyNo }}</p>
          <p>终端号：{{ terminal }}</p>
        </div>
      </div>
    </div>
    <div v-show="applyStatus === '04'">
      <img
        class="result_img"
        src="@/assets/img/mobile-img/sign-fail.png"
        alt=""
      />
      <p class="result_title">您的银联商务入驻申请，审核失败</p>
      <p class="result_fail_text">{{ failCause }}</p>
      <van-button round type="info" class="result_fail_btn" @click="againSign"
        >重新申请</van-button
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      applyStatus: "02",
      failCause: "失败失败失败失败失败失败失败失败失败失败",
      merNo: "",
      companyNo: "",
      terminal: "",
    };
  },
  created() {
    this.getStatus();
  },
  methods: {
    async getStatus() {
      let zwSelfContractType = this.$route.query.type;
      let ums_reg_id = this.$route.query.umsRegId;
      const res = await this.$apis.zzsignServe.applyStatusQuery({
        ums_reg_id,
        zwSelfContractType,
      });
      if (res.resultCode === "200") {
        if (res.data.res_code === "0000") {
          // 00：签约中--01：签约成功--02：入网审核中--03：入网成功/04：入网失败
          const { apply_status, fail_reason, mer_no, company_no } = res.data;
          this.applyStatus = apply_status;
          if (apply_status === "04") {
            this.failCause = fail_reason;
          } else if (apply_status === "03") {
            this.merNo = mer_no;
            this.companyNo = company_no;
            this.terminal =
              res.data.mapp_info_list[0].submchnt_info_list[0].term_app_no_list;
          }
        }
      }
    },
    againSign() {
      let type = this.$route.query.type;
      this.$router.replace(`/service-sign/form-service?type=${type}`);
    },
  },
};
</script>


<style scoped lang="scss">
.result_box {
  position: relative;
  padding-top: 120px;
  min-height: calc(100vh - 44px);
  overflow: hidden;
  text-align: center;
  .result_img {
    width: 96px;
    height: 92px;
  }
  .result_title {
    margin-top: 17px;
    padding: 0 105px;
    font-size: 15px;
    color: #333333;
    line-height: 21px;
  }
  .result_fail_text {
    margin-top: 11px;
    padding: 0 30px;
    font-size: 13px;
    color: #999999;
    line-height: 20px;
  }
  .result_fail_btn {
    margin-top: 18px;
    width: 315px;
    height: 44px;
  }

  .result_success_box {
    position: absolute;
    bottom: 34px;
    left: 97px;
    width: 100%;
    text-align: left;
    font-size: 13px;
    color: #999999;
    line-height: 23px;
  }
}
</style>